<template>
  <v-toolbar
    flat
  >
    <v-menu
      bottom
      right
    >
      <template v-slot:activator="{ on }">
        <v-btn
          text
          class="px-2"
          style="margin-left: -8px;"
          v-on="on"
        >
          <v-toolbar-title>{{ $t('HR.HRData') }}</v-toolbar-title>
          <v-icon
            v-if="$config.isWeb"
            right
          >
            {{ mdiMenuDown }}
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item to="/humanResources/PersonInfo">
          <v-list-item-title>{{ $t('HR.HRData') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="$config.isWeb"
          to="/humanResources/TrainingInfo"
        >
          <v-list-item-title>{{ $t('TrainingClient.TrainingRecord') }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="$config.isWeb"
          to="/humanResources/OtherInfo"
        >
          <v-list-item-title>{{ $t('HR.OtherData') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>

import siteIntegrate from '@/api/general/siteIntegrate'
import { mdiMenuDown } from '@mdi/js'

export default {
  components: {
  },
  data: function () {
    return {
      mdiMenuDown: mdiMenuDown
      // form: {}
    }
  },
  computed: {
    hrTrainingUrl () {
      return siteIntegrate.getHrTrainingUrl()
    }
  }
}

</script>
